import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './styles/artikelside.css';
import SEO from '../../components/SEO';
import Header from '../../components/header';
import Footer from '../../components/footer';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';

// Import individual article components
import SEOGuide2025 from './articles/seo-guide-2025';
import HvadKosterHjemmesider from './articles/hvad-koster-hjemmesider';
import WebdesignTrends from './articles/webdesign-trends';
import WebdesignFejlVirksomhederLaver from './articles/webdesign-fejl-virksomheder-laver';
import MinimalistiskWebdesign from './articles/minimalistisk-webdesign';
import VerdenMedAI from './articles/Verden-med-AI';
import MobilvenligeHjemmesider from './articles/mobilvenlige-hjemmesider';
import Designsystemer from './articles/designsystemer';
import GoogleIndeksering from './articles/google-indeksering';

const ArtikelOversigt = () => {
  const { slug } = useParams();
  const location = useLocation();
  
  // Always call hooks at the top level
  const [aktivKategori, setAktivKategori] = React.useState("Alle");
  const [søgning, setSøgning] = React.useState("");
  
  // Check for direct URL paths or slug from params
  const currentPath = location.pathname;
  const actualSlug = slug || (currentPath === '/hvad-koster-hjemmesider' ? 'hvad-koster-hjemmesider' : null);
  
  // Route to specific articles
  if (actualSlug === 'seo-guide-2025') {
    return <SEOGuide2025 />;
  }
  if (actualSlug === 'hvad-koster-hjemmesider') {
    return <HvadKosterHjemmesider />;
  }
  if (actualSlug === 'webdesign-trends-2025') {
    return <WebdesignTrends />;
  }
  if (actualSlug === 'webdesign-fejl-virksomheder-laver') {
    return <WebdesignFejlVirksomhederLaver />;
  }
  if (actualSlug === 'minimalistisk-webdesign') {
    return <MinimalistiskWebdesign />;
  }
  if (actualSlug === 'verden-med-ai') {
    return <VerdenMedAI />;
  }
  if (actualSlug === 'mobilvenlige-hjemmesider') {
    return <MobilvenligeHjemmesider />;
  }
  if (actualSlug === 'designsystemer') {
    return <Designsystemer />;
  }
  if (actualSlug === 'google-indeksering') {
    return <GoogleIndeksering />;
  }

  // Sample articles data - nu 6 artikler
  const artikler = [
    {
      id: 1,
      titel: "SEO Guide 2025: Alt du skal vide om søgemaskineoptimering",
      beskrivelse: "En komplet guide til SEO i 2025. Lær de vigtigste teknikker til at ranke højt på Google og tiltrække flere kunder til din hjemmeside.",
      kategori: "SEO",
      dato: "15. januar 2025",
      læsetid: "12 min",
      slug: "seo-guide-2025",
      billede: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2015&q=80",
      tags: ["SEO", "Google", "Digital Marketing"]
    },
    {
      id: 2,
      titel: "Hvad koster en hjemmeside i 2025? - Komplet prisguide",
      beskrivelse: "Få det fulde overblik over hvad en hjemmeside koster. Fra simple websites til komplekse webshops - læs vores detaljerede prisguide og få tips til at spare penge.",
      kategori: "Prisguide",
      dato: "2. september 2025",
      læsetid: "12 min",
      slug: "hvad-koster-hjemmesider",
      billede: require('../../images/showcase/CBS-PC.webp'),
      tags: ["Pris", "Hjemmeside", "Webdesign", "Budget"]
    },
    {
      id: 3,
      titel: "Webdesign Trends 2025: Fremtidens Hjemmesider",
      beskrivelse: "Discover de hotteste webdesign trends for 2025. Fra minimalistisk design til mobile-first approach - lær hvordan du skaber moderne hjemmesider der konverterer.",
      kategori: "Webdesign",
      dato: "3. september 2025",
      læsetid: "10 min",
      slug: "webdesign-trends-2025",
      billede: require('../../images/showcase/byggeriets-pc.webp'),
      tags: ["Webdesign", "Trends", "UX", "Mobile", "Design"]
    },
    {
      id: 4,
      titel: "10 Største Webdesign Fejl Virksomheder Laver",
      beskrivelse: "Undgå de mest almindelige webdesign fejl der koster virksomheder kunder. Lær hvordan dårlig brugervenlighed, langsom hastighed og forvirende navigation skader din online succes - og få konkrete løsninger.",
      kategori: "Webdesign",
      dato: "4. september 2025",
      læsetid: "8 min",
      slug: "webdesign-fejl-virksomheder-laver",
      billede: require('../../images/media/webdesign-fejl.png'),
      tags: ["Webdesign", "Fejl", "UX", "Brugervenlighed", "Optimering"]
    },
    {
      id: 5,
      titel: "Minimalistisk Webdesign: Skab Kraftfulde Hjemmesider Med Mindre",
      beskrivelse: "Oplev hvordan minimalistisk design kan transformere din hjemmeside. Lær de principper der skaber elegant funktionalitet, forbedrer brugeroplevelsen og øger konverteringen gennem fokuseret, clean design.",
      kategori: "Webdesign",
      dato: "8. september 2025",
      læsetid: "12 min",
      slug: "minimalistisk-webdesign",
      billede: require('../../images/showcase/psykologhagmund.webp'),
      tags: ["Minimalistisk", "Design", "UX", "Clean", "Brugeroplevelse"]
    },
    {
      id: 6,
      titel: "Verden Med AI - Hvordan Kunstig Intelligens Påvirker Din Online Tilstedeværelse",
      beskrivelse: "Oplev hvordan AI revolutionerer internettet og påvirker din hjemmeside. Lær hvordan du navigerer i den nye digitale virkelighed hvor AI er overalt.",
      kategori: "AI & Digital",
      dato: "25. september 2025",
      læsetid: "12 min",
      slug: "verden-med-ai",
      billede: require('../../images/media/Verden-med-AI.png'),
      tags: ["AI", "Kunstig Intelligens", "Digital Transformation", "Fremtiden", "Online"]
    },
    {
      id: 7,
      titel: "Mobilvenlige Hjemmesider: Hvorfor Din Virksomhed SKAL Være Mobile-First i 2025",
      beskrivelse: "Over 65% af al web-trafik kommer nu fra mobile enheder. Hvis din hjemmeside ikke er optimeret til mobil, mister du bogstaveligt talt kunder hver dag.",
      kategori: "Mobile & UX",
      dato: "30. september 2025",
      læsetid: "15 min",
      slug: "mobilvenlige-hjemmesider",
      billede: "https://images.unsplash.com/photo-1556075798-4825dfaaf498?w=400&h=200&fit=crop",
      tags: ["Mobile", "Responsive Design", "UX", "Google", "Performance"]
    },
    {
      id: 8,
      titel: "Designsystemer: Fundamentet for Skalerbart og Professionelt Webdesign",
      beskrivelse: "Lær hvordan designsystemer skaber sammenhæng, forbedrer effektiviteten og sikrer professionel kvalitet på tværs af hele din digitale tilstedeværelse.",
      kategori: "Design Guide",
      dato: "20. oktober 2025",
      læsetid: "12 min",
      slug: "designsystemer",
      billede: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=400&h=200&fit=crop",
      tags: ["Designsystem", "Design Tokens", "Komponenter", "UI", "Skalerbarhed"]
    },
    {
      id: 9,
      titel: "Hvordan Google Indekserer Din Hjemmeside - Den Komplette Guide",
      beskrivelse: "Forstå den fascinerende proces bag hvordan Google finder, crawler, render og indekserer din hjemmeside. Lær alt fra crawling til ranking og optimer din side til bedre synlighed.",
      kategori: "SEO",
      dato: "4. november 2025",
      læsetid: "10 min",
      slug: "google-indeksering",
      billede: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80",
      tags: ["Google", "Indeksering", "Crawler", "SEO", "Søgemaskine"]
    },
    {
      id: 10,
      titel: "SEO og AI-søgninger i 2026: Den Komplette Guide",
      beskrivelse: "Lær hvordan AI-søgninger som ChatGPT og Google SGE ændrer SEO, og hvordan du gør dit indhold klar til AI-søgninger i 2026.",
      kategori: "SEO",
      dato: "12. januar 2026",
      læsetid: "18 min",
      slug: "seoogaii2026",
      billede: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop",
      tags: ["SEO 2026", "AI-søgninger", "Google SGE", "ChatGPT", "Semantisk SEO"]
    }
  ];

  const kategorier = ["Alle", "SEO", "Prisguide", "Webdesign", "AI & Digital", "Mobile & UX", "Design Guide"];

  // Filter og søg funktionalitet
  const filtrerdeArtikler = artikler.filter(artikel => {
    const matcherKategori = aktivKategori === "Alle" || artikel.kategori === aktivKategori;
    const matcherSøgning = søgning === "" || 
      artikel.titel.toLowerCase().includes(søgning.toLowerCase()) ||
      artikel.beskrivelse.toLowerCase().includes(søgning.toLowerCase()) ||
      artikel.tags.some(tag => tag.toLowerCase().includes(søgning.toLowerCase()));
    
    return matcherKategori && matcherSøgning;
  });

  return (
    <div className="artikelside-page">
      <SEO 
        title="Artikler - Parla Branding | SEO og Webdesign Guides"
        description="Læs vores ekspert guides om SEO, webdesign og digital marketing. Få værdifulde tips til at forbedre din hjemmeside og online tilstedeværelse."
        keywords="webdesign artikler, SEO guides, hjemmeside tips, website optimering, digital marketing guides, professionelle hjemmesider tips"
        url="/artikler"
        type="website"
        canonicalUrl="https://www.parlabranding.dk/artikler"
      />
      
      <Header />
      
      <main className="artikelside-main">
        {/* Hero Section */}
        <section className="artikelside-hero">
          <div className="container">
            <div className="artikelside-hero-content">
              <h1 className="artikelside-hero-title">Artikler</h1>
              <p className="artikelside-hero-description">
                Læs vores guides og tips om SEO, webdesign og digital marketing
              </p>
            </div>
          </div>
        </section>

        {/* Søg og Filter */}
        <section className="artikelside-search">
          <div className="container">
            <div className="artikelside-search-content">
              <div className="artikelside-search-bar">
                <input
                  type="text"
                  placeholder="Søg i artikler..."
                  value={søgning}
                  onChange={(e) => setSøgning(e.target.value)}
                  className="artikelside-search-input"
                />
                <div className="artikelside-search-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <div className="artikelside-filter-categories">
                {kategorier.map((kategori) => (
                  <button
                    key={kategori}
                    className={`artikelside-category-btn ${aktivKategori === kategori ? 'active' : ''}`}
                    onClick={() => setAktivKategori(kategori)}
                  >
                    {kategori}
                  </button>
                ))}
              </div>
              {filtrerdeArtikler.length === 0 && (søgning || aktivKategori !== "Alle") && (
                <div className="artikelside-no-results">
                  <p>Ingen artikler matcher din søgning. Prøv andre søgeord eller vælg en anden kategori.</p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="artikelside-grid">
          <div className="container">
            <div className="artikelside-artikler">
              {filtrerdeArtikler.map((artikel) => (
                <article key={artikel.id} className="artikelside-artikel-card">
                  {artikel.billede && (
                    <div className="artikelside-artikel-image">
                      <img 
                        src={artikel.billede} 
                        alt={artikel.titel}
                        className="artikelside-artikel-img"
                      />
                    </div>
                  )}
                  <div className="artikelside-artikel-header">
                    <div className="artikelside-artikel-meta">
                      <span className="artikelside-kategori">{artikel.kategori}</span>
                      <span className="artikelside-dato">{artikel.dato}</span>
                      <span className="artikelside-læsetid">{artikel.læsetid}</span>
                    </div>
                  </div>
                  <div className="artikelside-artikel-content">
                    <h3 className="artikelside-artikel-title">{artikel.titel}</h3>
                    <p className="artikelside-artikel-beskrivelse">{artikel.beskrivelse}</p>
                    <div className="artikelside-artikel-tags">
                      {artikel.tags.map((tag, index) => (
                        <span key={index} className="artikelside-tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                  <div className="artikelside-artikel-footer">
                    <CTAKnap 
                      variant="outline" 
                      size="medium"
                      href={`/artikler/${artikel.slug}`}
                      icon={<CTAIkoner.ArrowRight />}
                    >
                      Læs artikel
                    </CTAKnap>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter CTA */}
        <section className="artikelside-newsletter">
          <div className="container">
            <div className="artikelside-newsletter-content">
              <h2>Få nye artikler direkte i din indbakke</h2>
              <p>Tilmeld dig vores nyhedsbrev og vær først til at læse vores seneste guides og tips.</p>
              <div className="artikelside-newsletter-actions">
                <CTAKnap 
                  variant="primary" 
                  size="large"
                  href="/kontakt#nyhedsbrev"
                  icon={<CTAIkoner.ArrowRight />}
                >
                  Tilmeld nyhedsbrev
                </CTAKnap>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default ArtikelOversigt;
